import { Injectable } from "@angular/core"
import { BehaviorSubject, Observable } from "rxjs"
import { Resource } from "../models/resource/resource"

@Injectable()
export class PreviewService {
    private _previewOnResource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    private _previewOnCollection: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    private _resource$: BehaviorSubject<Resource> = new BehaviorSubject<Resource>(null)

    get previewOnResource$(): Observable<boolean> {
        return this._previewOnResource.asObservable()
    }

    get previewOnResource(): boolean {
        return this._previewOnResource.value
    }

    set previewOnResource(value: boolean) {
        this._previewOnResource.next(value)
    }

    get previewOnCollection$(): Observable<boolean> {
        return this._previewOnCollection.asObservable()
    }

    get previewOnCollection(): boolean {
        return this._previewOnCollection.value
    }

    set previewOnCollection(value: boolean) {
        this._previewOnCollection.next(value)
    }

    get resource(): Resource {
        return this._resource$.value
    }

    get resource$(): Observable<Resource> {
        return this._resource$.asObservable()
    }

    set resource(value: Resource) {
        this._resource$.next(value)
    }
}
